import React from 'react';

const services = [
  {
    icon: 'ri-home-4-line',
    title: 'Roofing',
    description:
      'Complete roof replacements, repairs, and inspections using premium materials built to last.',
    anchor: 'roofing-section',
  },
  {
    icon: 'ri-layout-column-line',
    title: 'Siding',
    description:
      "Vinyl, fiber cement, and engineered wood siding that transforms your home's curb appeal.",
    anchor: 'siding-section',
  },
  {
    icon: 'ri-drop-line',
    title: 'Gutters',
    description:
      'Seamless gutter systems and leaf guards that protect your foundation year-round.',
    anchor: 'gutters-section',
  },
  {
    icon: 'ri-thunderstorms-line',
    title: 'Storm Restoration',
    description:
      'Fast emergency response with full insurance claim assistance after hail, wind, or storm damage.',
    anchor: 'storm-section',
  },
] as const;

/**
 * Safely scrolls the page to an element with the given id.
 * Includes basic error handling to avoid runtime crashes if the element does not exist.
 */
const safeScrollTo = (id: string) => {
  try {
    const el = document.getElementById(id);
    if (!el) {
      console.warn(`Element with id "${id}" not found. Skipping scroll.`);
      return;
    }
    el.scrollIntoView({ behavior: 'smooth' });
  } catch (error) {
    console.error('Unexpected error while scrolling:', error);
  }
};

export default function ServicesOverview() {
  return (
    <section className="py-20 bg-white relative z-10">
      <div className="max-w-7xl mx-auto px-8 lg:px-16">
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-3 mb-5">
            <div className="w-2 h-2 rounded-full bg-neon-green"></div>
            <span className="text-xs uppercase tracking-widest font-medium text-gunmetal">
              Full-Service Exterior Solutions
            </span>
            <div className="w-2 h-2 rounded-full bg-neon-green"></div>
          </div>
          <h2 className="text-3xl lg:text-4xl font-bold text-matte-black mb-4">
            Everything Your Home Needs,{' '}
            <span className="text-neon-green">Under One Roof</span>
          </h2>
          <p className="text-base text-gunmetal max-w-2xl mx-auto">
            IronCore Roofing &amp; Exteriors is your single source for roofing, siding,
            gutters, and storm restoration across Pennsylvania.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((svc, idx) => (
            <button
              key={idx}
              type="button"
              onClick={() => safeScrollTo(svc.anchor)}
              className="text-left bg-gray-50 rounded-xl p-7 border border-gray-100 hover:border-neon-green/40 hover:shadow-lg transition-all duration-300 group cursor-pointer"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-neon-green/10 rounded-xl mb-5 group-hover:bg-neon-green/20 transition-colors">
                <i className={`${svc.icon} text-neon-green text-2xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-matte-black mb-2">{svc.title}</h3>
              <p className="text-sm text-gunmetal leading-relaxed mb-4">{svc.description}</p>
              <span className="text-sm font-semibold text-neon-green flex items-center gap-1 group-hover:gap-2 transition-all">
                Learn More <i className="ri-arrow-right-line"></i>
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
